import { render, staticRenderFns } from "./RollBetsElement.vue?vue&type=template&id=3610b6df&scoped=true"
import script from "./RollBetsElement.vue?vue&type=script&lang=js"
export * from "./RollBetsElement.vue?vue&type=script&lang=js"
import style0 from "./RollBetsElement.vue?vue&type=style&index=0&id=3610b6df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3610b6df",
  null
  
)

export default component.exports